import { Component } from '@angular/core';

@Component({
  selector: 'app-wcl-admin',
  standalone: false,
  templateUrl: './wcl-admin.component.html',
  styleUrls: ['./wcl-admin.component.scss'],
})
export class WCLAdminComponent {}
